import { render } from "./DisplayTemplate.vue?vue&type=template&id=b876d39a&ts=true"
import script from "./DisplayTemplate.vue?vue&type=script&lang=ts"
export * from "./DisplayTemplate.vue?vue&type=script&lang=ts"

import "./DisplayTemplate.vue?vue&type=style&index=0&id=b876d39a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__